/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function findManyEstateFeatures (params?: Record<string, any>): Promise<HalDocument<{
  estateFeatures: EstateFeature[]
}>> {
  return rest.get(`/api/estate-features?${stringify(params)}`)
    .then((resp) => resp.json())
}
